export default __webpack_public_path__ + "static/media/flag-nigeria.efaa3dde.svg";